/// <amd-module name="Wit/WorkItemFormMarkdown/NestedListsPlugin" />
import * as TurndownService from "turndown";

// This is altered code from https://github.com/mixmark-io/turndown/issues/232 with typescript and support for multiple levels of nested lists.

const rules: { [key: string]: TurndownService.Rule } = {};

rules.list = {
    filter: ["ul", "ol"],
    replacement: function (content, node) {
        var parent = node.parentNode;

        // Allow for <ul> and <ol> that are improperly nested outside of <li>.
        if (parent?.nodeName.match(/^(UL|OL)$/i)) {
            content =
                "    " +
                content
                    .replace(/^\n+/, "") // remove leading newlines
                    .replace(/\n+$/, "\n") // replace trailing newlines with just a single one
                    .replace(/\n/gm, "\n    ") // indent
                    .replace(/(\n    )+$/, ""); // remove newline with indent if the content ends with it
        }

        if (parent?.nodeName.toUpperCase() === "LI" && parent?.lastElementChild === node) {
            return "\n" + content;
        } else {
            return "\n" + content + "\n";
        }
    }
};

rules.listItem = {
    filter: "li",
    replacement: function (content, node, options) {
        content = content
            .replace(/^\n+/, "") // remove leading newlines
            .replace(/\n+$/, "\n") // replace trailing newlines with just a single one
            .replace(/\n/gm, "\n    "); // indent

        var prefix = options.bulletListMarker + "   ";
        var parent = node.parentNode;

        // Don't output two markers if there is an empty li.
        if (node.children.length === 1 && node.children[0].nodeName.match(/^(UL|OL)$/i) && node.textContent === node.children[0].textContent) {
            prefix = "    ";
        } else if (parent?.nodeName.toUpperCase() === "OL") {
            var start = (parent as any).getAttribute("start");
            // When <ol> is improperly nested outside of <li>, get the numbering correct.
            var index = Array.prototype.indexOf.call(
                Array.prototype.filter.call(parent.children, el => el.nodeName.toUpperCase() === "LI"),
                node
            );
            prefix = (start ? Number(start) + index : index + 1) + ".  ";
        }

        return prefix + content + (node.nextSibling && !/\n$/.test(content) ? "\n" : "");
    }
};

export function nestedLists(turndownService: TurndownService) {
    for (let key in rules) {
        turndownService.addRule(key, rules[key]);
    }
}
